import React from "react";

const NoteIcon = ({ iconClass, color, strokeWidth }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      className={iconClass}
    >
      <path
        d="M8.68262 2.5V5.5"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.6826 2.5V5.5"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.68262 13.5H15.6826"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.68262 17.5H12.6826"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.6826 4C20.0126 4.18 21.6826 5.45 21.6826 10.15V16.33C21.6826 20.45 20.6826 22.51 15.6826 22.51H9.68262C4.68262 22.51 3.68262 20.45 3.68262 16.33V10.15C3.68262 5.45 5.35262 4.19 8.68262 4H16.6826Z"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default NoteIcon;
